import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { IEDisplayProperties, InterfaceElement } from 'src/app/model/asd/asd-properties/asd-ie/asd-interfaceElement';
import { BreadCrumbItem } from 'src/app/model/breadCrumb/breadCrumbItem';
import { UXControllerService } from 'src/app/service/controller/ux-controller.service';
import { CosyHtmlElementGenerationService } from 'src/app/service/generator/generator-html/cosy-html-element-generation.service';

@Component({
  selector: 'app-cosy-label',
  templateUrl: './cosy-label.component.html',
  styleUrls: ['./cosy-label.component.css']
})
export class CosyLabelComponent implements OnInit {

  @Input() ie: InterfaceElement;
  @Input() formgroup: FormGroup;
  @Output() loadHistory: EventEmitter<any> = new EventEmitter<any>();
  @Input() breadCrumb: BreadCrumbItem[] = [];

  public labelDisplayType: string = 'specific';
  public class: string = '';


  constructor(private uxControllerService: UXControllerService, private cosyHtmlElementGenerationService: CosyHtmlElementGenerationService) { }

  ngOnInit() {

    if (this.ie.CustomizeOptions != null && this.ie.CustomizeOptions.DisplayType == 'progressbar') {
      this.ie.CustomizeOptions.Properties.ProgBarValue = this.ie.Values[0].Value;
      this.ie.Label.TextShort = this.ie.Label.TextShort.replace(/<MAX>/g, this.ie.CustomizeOptions.Properties.ProgBarMax.toString());
      this.ie.Label.TextLong = this.ie.Label.TextLong.replace(/<MAX>/g, this.ie.CustomizeOptions.Properties.ProgBarMax.toString());
      this.ie.Label.TextShort = this.ie.Label.TextShort.replace(/<VALUE>/g, this.ie.CustomizeOptions.Properties.ProgBarValue.toString());
      this.ie.Label.TextLong = this.ie.Label.TextLong.replace(/<VALUE>/g, this.ie.CustomizeOptions.Properties.ProgBarValue.toString());
    }

    this.ie.Label.TextShort = this.ie.Label.TextShort.replace(new RegExp('\n', 'g'), '<br />');
    this.ie.Label.TextLong = this.ie.Label.TextLong.replace(new RegExp('\n', 'g'), '<br />');
    /*if (this.ie.Label.DisplayName !== '' && 
        this.ie.Label.TextShort !== '' && 
        this.ie.Label.TextLong !== '' && 
        this.ie.Label.DisplayName !== '') {
      this.labelDisplayType = 'simple';
    }*/
    if ((this.ie.Label.DisplayName == "" && this.ie.Label.TextShort.indexOf('%%') > -1 && this.ie.Label.TextLong.indexOf('%%') > -1) || (this.ie.Label.DisplayName !== '' && this.ie.Label.TextShort !== '' && this.ie.Label.TextLong !== '')) {
      this.labelDisplayType = 'simple';
    }
    if (this.ie.Label.DisplayName.indexOf('%%ApplicationName%%') > -1 || 
       (this.ie.DisplayProperties != null && this.ie.DisplayProperties.DisplayName.indexOf('%%ApplicationName%%')> -1) ){
     
      if(this.ie.DisplayProperties == null){
        this.ie.DisplayProperties = new IEDisplayProperties();
        this.ie.DisplayProperties.DisplaySrcKey = 'Label';
        this.ie.DisplayProperties.DisplayName = '%%ApplicationName%%';
      }
        
      this.ie.Label.DisplayName = this.ie.Label.DisplayName.replace('%%ApplicationName%%', this.uxControllerService.appName);
      this.class = 'appNameStyle';
    }
  }

  loadAppPageFromHistory(){
    this.loadHistory.emit(this.uxControllerService.appSessionID);
  }
}
